import { createSearchPageSlice } from '../../../../Generic/SearchPage/slices/searchPageSlice';
import { SortDirection } from '../../../../../utils/constants';

export const filterFields = {
  clientName: 'clientName',
  ShortName: 'ShortName',
  SourceSystemId: 'SourceSystemId',
  active: 'active',
};
const initialFilterState = {
  clientName: '',
  ShortName: '',
  SourceSystemId: '',
  active: true,
};

const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'CreatedOn',
  sortDirection: SortDirection.Desc,
};
export const sliceName = 'PetrohubclientSearch';
const PetrohubclientSearchSlice = createSearchPageSlice({
  sliceName,
  filterFields,
  initialFilterState,
  initialPageState
});
export const PetrohubclientSearchActions = PetrohubclientSearchSlice.actions;
export default PetrohubclientSearchSlice.reducer;
